exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "number-list {\n  display: block;\n  position: relative;\n}\nnumber-list .row-number {\n  margin-bottom: 5px;\n}\nnumber-list .row-number button {\n  display: inline-block;\n}\nnumber-list [type=\"number\"],\nnumber-list [type=\"text\"],\nnumber-list .add-new {\n  display: inline-block;\n  width: calc(100% - 75px);\n}\nnumber-list .add-new {\n  padding: 1px 5px;\n  margin-bottom: 5px;\n  margin-right: 10px;\n}\nnumber-list .btn-group-spel {\n  display: inline-block;\n  position: absolute;\n  right: 0;\n  top: 5px;\n}\n.no-spel number-list .btn-group-spel {\n  display: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/core/src/forms/numberList/numberList.component.less
// module id = 3269
// module chunks = 0